<template>
    <div class="post-comments-wrap">
        <h1 class="d-flex align-center gap-2">Comments <span class="comments-number">8</span></h1>

        <ul class="post-comments mt-30px">

            <li class="post-comment">
                <div class="comment">
                    <div class="post-author">
                        <img :src="require('@/assets/images/team-4.png')" alt="author">
                    </div>
                    <div class="post-comment-body">
                        <h4 class="post-comment-author d-flex align-center gap-2">tanbir <span class="post-comment-date">4 hours ago</span></h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat reiciendis nesciunt dolorum rerum, aliquam aspernatur non odit corrupti repudiandae, totam quae ullam eius illo esse.</p>
                        <a href="#" class="post-comment-reply-btn">Reply</a>
                    </div>
                </div>

                <ul class="children-comments">
                    <li class="post-comment">
                        <div class="comment">
                            <div class="post-author">
                                <img :src="require('@/assets/images/team-1.png')" alt="author">
                            </div>
                            <div class="post-comment-body">
                                <h4 class="post-comment-author d-flex align-center gap-2">tanbir <span class="post-comment-date">4 hours ago</span></h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat reiciendis nesciunt dolorum rerum, aliquam aspernatur non odit corrupti repudiandae, totam quae ullam eius illo esse.</p>
                                <a href="#" class="post-comment-reply-btn">Reply</a>
                            </div>
                        </div>
                    </li>
                    <li class="post-comment">
                        <div class="comment">
                            <div class="post-author">
                                <img :src="require('@/assets/images/team-3.png')" alt="author">
                            </div>
                            <div class="post-comment-body">
                                <h4 class="post-comment-author d-flex align-center gap-2">tanbir <span class="post-comment-date">4 hours ago</span></h4>
                                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolores ullam excepturi nam! Minus ipsa dolorem suscipit hic perferendis magni, voluptate harum sapiente ex sit natus?</p>
                                <a href="#" class="post-comment-reply-btn">Reply</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li class="post-comment">
                <div class="comment">
                    <div class="post-author">
                        <img :src="require('@/assets/images/team-1.png')" alt="author">
                    </div>
                    <div class="post-comment-body">
                        <h4 class="post-comment-author d-flex align-center gap-2">tanbir <span class="post-comment-date">4 hours ago</span></h4>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa, earum. Atque incidunt unde natus corporis officiis dolore harum nostrum voluptatem similique, sequi quis ea pariatur, praesentium culpa ab aperiam accusantium.</p>
                        <a href="#" class="post-comment-reply-btn">Reply</a>
                    </div>
                </div>
            </li>
            
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Comments'
}
</script>